import { useQuery, UseQueryOptions } from 'react-query';

import { QueryKeys } from '.';
import { useApi } from '../../context';
import { AxiosUtils } from '../../utils';
import { Guid, Company } from '../../models';
import { CerebroApiEndpoints } from '../../utils/api';

export function useCompanyQuery(
	dealGuid?: Guid | undefined,
	options?: Omit<UseQueryOptions<Company, unknown, Company, any>, 'queryKey' | 'queryFn'> | undefined
) {
	const api = useApi();

	return useQuery(
		QueryKeys.Company.Root(dealGuid),
		() => AxiosUtils.getResponseData<Company>(api.get(CerebroApiEndpoints.Company.Root(dealGuid))),
		options
	);
}
